import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Row, Col, Button, Input, Label, ModalHeader, ModalFooter, ModalBody, Form, FormGroup } from 'reactstrap'
import { validateItem } from '../_validate'
import { Field, reduxForm, change, formValueSelector } from 'redux-form'
import PropTypes from 'prop-types'

import { selectHelper, normalizeHelper } from '../../../../../common/helpers'

class FormItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            activeItem: {
                id: null,
                name: null,
                price: null
            },
            flagDiscount: true,
        }
        this.onSubmitOfferItem = this.onSubmitOfferItem.bind(this);
        this.renderInputField = this.renderInputField.bind(this);
        this.renderItemsModal = this.renderItemsModal.bind(this);
        this.renderStaticField = this.renderStaticField.bind(this);
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.selectedItem != this.props.selectedItem) {
            await this.setState({ activeItem: this.props.selectedItem })
            this.props.changeValueForm('OfferItemForm', 'id', this.state.activeItem.id)
        }
        if (this.state.activeItem != null) {
            this.checkValueChange(prevProps)
            this.checkItemChange(prevProps)
            this.props.changeValueForm('OfferItemForm', 'before_price', this.state.activeItem.price)
        }
    }
    checkItemChange(prevProps) {
        if (this.props.itemId != prevProps.itemId) {
            if (this.props.itemType == 'Productos') {
                this.setState({
                    activeItem: selectHelper.getFromDataByLabel('id', this.props.itemId, this.props.products)
                })
            }
            else if (this.props.itemType == 'Servicios') {
                this.setState({
                    activeItem: selectHelper.getFromDataByLabel('id', this.props.itemId, this.props.services)
                })
            }
        }
    }

    checkValueChange(prevProps) {
        if (!this.state.flagDiscount && this.props.itemPrice != null) {
            const discount = 100 - ((this.props.itemPrice / this.state.activeItem.price) * 100)
            if (discount == this.props.itemDiscount) return
            this.props.changeValueForm('OfferItemForm', 'discount', discount.toFixed(2))
        }
        else if (this.state.flagDiscount && this.props.itemDiscount != null) {
            const price = (((100 - this.props.itemDiscount) * this.state.activeItem.price) / 100)
            if (price == this.props.itemPrice) return
            this.props.changeValueForm('OfferItemForm', 'price', price.toFixed(2))
        }
    }

    toggleModal(itemType) {
        this.props.toggleModal(itemType)
    }
    onSubmitOfferItem(values) {
        if (this.state.activeItem == null) return
        this.props.onSubmitOfferItem(values, this.state.activeItem);
    }

    renderProductsItems() {
        return this.props.products.map(product => {
            return (
                <option key={product.id} value={product.id}>{product.name}</option>
            )
        })
    }
    renderServicesItems() {
        return this.props.services.map(service => {
            return (
                <option key={service.id} value={service.id}>{service.name}</option>
            )
        })
    }
    renderInputField(field) {
        const { meta: { touched, error } } = field;
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'

        return (
            <FormGroup row >
                <Col md='2' lg='3'>
                    <Label className={labelClass}>{field.label}</Label>
                </Col>
                <Col>
                    <Input {...field.input} invalid={hasError} type={field.type} onKeyDown={field.onKeyDown}></Input>
                </Col>
            </FormGroup>
        )
    }

    renderStaticField(field) {
        const { meta: { touched, error } } = field;
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'

        return (
            <FormGroup row >
                <Col md='2' lg='3'>
                    <Label className={labelClass}>{field.label}</Label>
                </Col>
                <Col>
                    <Input {...field.input} invalid={hasError} type={field.type} readOnly />
                </Col>
            </FormGroup>
        )
    }

    renderItemsModal(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false

        return (
            <FormGroup row>
                <Col md='3'>
                    <Label htmlFor="button">{this.props.itemType} *:</Label>
                </Col>
                <Col>
                    {/* <Input {...field.input} type="select" invalid={hasError} >
                        <option key={0} value={0}>Seleccione...</option>
                        {this.props.itemType == 'Productos' ? (
                            this.renderProductsItems()
                        ) : (
                                this.renderServicesItems()
                            )}
                    </Input> */}
                    <span>{(this.state.activeItem) ? this.state.activeItem.name : ''}</span>
                </Col>
                <Col md='2'>
                    <Button color='primary' onClick={this.props.toggleItemModal}><i className="fa fa-edit" /></Button>
                </Col>
            </FormGroup>
        )
    }

    render() {
        const { handleSubmit } = this.props
        return (
            <Form onSubmit={handleSubmit(handleSubmit(this.onSubmitOfferItem))}>
                <ModalHeader>Añadir Item</ModalHeader>
                <ModalBody>
                    <Field name='id' component={this.renderItemsModal} />
                    <Field name='discount' label='Descuento(%) *:' onKeyDown={() => { this.state.flagDiscount = true; }} component={this.renderInputField} normalize={normalizeHelper.decimalOnlyField(0, 100)} />
                    <Field name='before_price' label='Precio Actual(S/) *:' component={this.renderStaticField} normalize={normalizeHelper.decimalOnlyField()} />
                    <Field name='price' label='Nuevo Precio(S/) *:' onKeyDown={() => { this.state.flagDiscount = false; }} component={this.renderInputField} normalize={normalizeHelper.decimalOnlyField(this.state.activeItem ? 0 : undefined, this.state.activeItem ? this.state.activeItem.price : undefined)} />
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col className='mt-3'>
                            <Button type='submit' color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                            <Button color='secondary' onClick={() => this.toggleModal()} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
                        </Col>
                    </Row>
                </ModalFooter>

            </Form>
        )
    }
}

FormItem.propTypes = {

    products: PropTypes.array,
    services: PropTypes.array,
    selectedItem: PropTypes.object,
    itemType: PropTypes.string,
    onSubmitOfferItem: PropTypes.func,
    toggleModal: PropTypes.func,
    toggleItemModal: PropTypes.func,

}

const formSelector = formValueSelector('OfferItemForm')

function mapStateToProps(state) {
    return {
        itemPrice: formSelector(state, 'price'),
        itemId: formSelector(state, 'id'),
        itemDiscount: formSelector(state, 'discount'),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeValueForm: change
    }, dispatch)
}

export default reduxForm({
    form: 'OfferItemForm',
    touchOnBlur: false,
    // enableReinitialize: true,
    validate: validateItem
})(connect(mapStateToProps, mapDispatchToProps)(FormItem))


// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferAdd/Forms/FormItem.js